import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CgClose } from 'react-icons/cg';
import { setDynamicModalObj } from '../../store/board.actions';
import { loadGroupsListaUsuarios, loadGroupsWithUactividades } from "../../store/grupo.actions";
import { userService } from '../../services/user.service';

import '../../assets/styles/member-filter-modal.css';

export function MemberFilterModal({ dynamicModalObj }) {
    const members = useSelector(storeState => storeState.userModule.users);
    const [user, setUser] = useState(userService.getLoggedinUser().data.data);
    const { boardId } = useParams();

    function onFilterBoard(memberId) {
        const updatedMembers = [...dynamicModalObj.filterBy.memberIds];
    
        // Alternar ID de miembro en miembros actualizados
        const isMemberSelected = updatedMembers.includes(memberId);
        const updatedMembersFiltered = isMemberSelected
            ? updatedMembers.filter(id => id !== memberId)
            : [...updatedMembers, memberId];
    
        // Update dynamicModalObj.filterBy and setFilterBy
        dynamicModalObj.filterBy.memberIds = updatedMembersFiltered;
        dynamicModalObj.setFilterBy({ ...dynamicModalObj.filterBy });
    
        // Determinar qué función llamar según los miembros actualizados
        if (updatedMembersFiltered.length > 0) {
            loadGroupsListaUsuarios(boardId, updatedMembersFiltered);
        } else {
            loadGroupsWithUactividades(boardId);
        }
    }

    // Ordenar miembros por longitud del nombre de manera descendente

    // Dividir la lista de miembros en dos columnas
    const halfLength = Math.ceil(members.length / 2);
    const column1 = members.slice(0, halfLength);
    const column2 = members.slice(halfLength);

    return (
        <section className="filter-member-modal flex column">
            <CgClose className="close-btn" onClick={() => setDynamicModalObj({ isOpen: false })} />
            <h2>Filtro de Persona</h2>
            <div className="secondary-title">Filtrar actividades por Responsable</div>
            <div className="columns-container">
                <ul className="column">
                    {column1.map(member => (
                        <li 
                            key={member.id_usuario} 
                            className={dynamicModalObj.filterBy.memberIds.includes(member.id_usuario) ? 'active' : ''}
                            onClick={() => onFilterBoard(member.id_usuario)}
                        >
                            <img src={member.imgurl} alt={member.nombre} />
                            <span>{member.nombre}</span>
                        </li>
                    ))}
                </ul>
                <ul className="column">
                    {column2.map(member => (
                        <li 
                            key={member.id_usuario} 
                            className={dynamicModalObj.filterBy.memberIds.includes(member.id_usuario) ? 'active' : ''}
                            onClick={() => onFilterBoard(member.id_usuario)}
                        >
                            <img src={member.imgurl} alt={member.nombre} />
                            <span>{member.nombre}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}




// import { useParams } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { CgClose } from 'react-icons/cg';
// import { setDynamicModalObj } from '../../store/board.actions';
// import { loadGroupsListaUsuarios,loadGroupsWithUsuarios } from "../../store/grupo.actions";
// import { userService } from '../../services/user.service';

// import '../../assets/styles/member-filter-modal.css';

// export function MemberFilterModal({ dynamicModalObj }) {
//     const members = useSelector(storeState => storeState.userModule.users);
//     const [user, setUser] = useState(userService.getLoggedinUser().user);
//     const { boardId } = useParams();

//     function onFilterBoard(memberId) {
//         const updatedMembers = [...dynamicModalObj.filterBy.memberIds];
    
//         // Alternar ID de miembro en miembros actualizados
//         const isMemberSelected = updatedMembers.includes(memberId);
//         const updatedMembersFiltered = isMemberSelected
//             ? updatedMembers.filter(id => id !== memberId)
//             : [...updatedMembers, memberId];
    
//         // Update dynamicModalObj.filterBy and setFilterBy
//         dynamicModalObj.filterBy.memberIds = updatedMembersFiltered;
//         dynamicModalObj.setFilterBy({ ...dynamicModalObj.filterBy });
    
//         // Determinar qué función llamar según los miembros actualizados
//         if (updatedMembersFiltered.length > 0) {
//             loadGroupsListaUsuarios(boardId, updatedMembersFiltered);
//         } else {
//             loadGroupsWithUsuarios(boardId, user.id_usuario);
//         }
//     }

//     // Ordenar miembros por longitud del nombre de manera descendente
    

//     return (
//         <section className="filter-member-modal flex column">
//             <CgClose className="close-btn" onClick={() => setDynamicModalObj({ isOpen: false })} />
//             <h2>Filtro de Persona</h2>
//             <div className="secondary-title">Filtrar actividades por Responsable</div>
//             <ul>
//                 {
//                     members.map(member => (
//                         <li 
//                             key={member.id_usuario} 
//                             className={dynamicModalObj.filterBy.memberIds.includes(member.id_usuario) ? 'active' : ''}
//                             onClick={() => onFilterBoard(member.id_usuario)}>
//                             <img src={member.imgurl} alt={member.nombre} />
//                             <span>{member.nombre}</span>
//                         </li>
//                     ))
//                 }
//             </ul>
//         </section>
//     );
// }


